"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StdoutTransport = void 0;
var StdoutTransport = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    function StdoutTransport(formatter) {
        this.formatter = formatter;
    }
    StdoutTransport.prototype.write = function (rawLog) {
        // eslint-disable-next-line no-console
        console.log(this.formatter.format(rawLog));
    };
    return StdoutTransport;
}());
exports.StdoutTransport = StdoutTransport;
//# sourceMappingURL=Stdout.js.map